// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e3d98483","803":"e8490a4a"}[chunkId] + ".chunk.js";
};